// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".store-selector[data-v-4051cb66]{width:100%}.store-selector__filter[data-v-4051cb66]{margin-bottom:8px}.store-selector__tag[data-v-4051cb66]{margin-left:6px}", ""]);
// Exports
module.exports = exports;
